import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ProxyService } from '../../services/proxy/proxy.service';
import { Global } from '../../classes/global';

@Component({
  selector: 'app-proxy-source-list',
  templateUrl: './proxy-source-list.component.html',
  styleUrls: ['./proxy-source-list.component.scss']
})
export class ProxySourceListComponent implements OnInit {
  @ViewChild('sourceModal') sourceModal: ElementRef;

  sources: any[] = [];
  total = 0;
  query = { queryString: '', pageSize: 100, pageNumber: 1 };

  editingSource: any = {};
  isNew = false;

  constructor(
    private proxyService: ProxyService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public global: Global
  ) {}

  ngOnInit() {
    this.loadSources();
  }

  loadSources() {
    this.global.pageLoading = true;
    this.proxyService.querySources(this.query).subscribe(
      (res: any) => {
        this.sources = res.items || [];
        this.total = res.total || 0;
        this.global.pageLoading = false;
      },
      () => { this.global.pageLoading = false; }
    );
  }

  search() {
    this.query.pageNumber = 1;
    this.loadSources();
  }

  openModal(source?: any) {
    if (source) {
      this.isNew = false;
      this.editingSource = { id: source.id, name: source.name, note: source.note };
    } else {
      this.isNew = true;
      this.editingSource = { name: '', note: '' };
    }
    this.modalService.open(this.sourceModal, { windowClass: 'lModal' });
  }

  save() {
    this.global.pageLoading = true;
    this.proxyService.saveSource(this.editingSource).subscribe(
      () => {
        this.toastr.success(this.isNew ? 'Created' : 'Updated');
        this.modalService.dismissAll();
        this.loadSources();
      },
      (err: any) => {
        this.toastr.error(err.error || 'Error');
        this.global.pageLoading = false;
      }
    );
  }

  deleteSource(id: string) {
    if (!confirm('Are you sure?')) return;
    this.global.pageLoading = true;
    this.proxyService.deleteSource(id).subscribe(
      () => {
        this.toastr.success('Deleted');
        this.loadSources();
      },
      (err: any) => {
        this.toastr.error(err.error || 'Error');
        this.global.pageLoading = false;
      }
    );
  }

  onPageChange(page: number) {
    this.query.pageNumber = page;
    this.loadSources();
  }
}
